import Instadate from 'instadate';
import { formActions } from 'redux-pure-form';
import { getUserOrganizations } from './organization.js';
import {
    getOrganizationSettings,
    selectOrganizationsListByNonExpired
} from '../reducers/organization.js';
import { getCalendarLocationsByOrgs } from './location.js';
import { getCalendarResourcesByOrgs } from './resource.js';
import { getCalendarPilotsByOrgs } from './user.js';
import { selectLocationsByOrg } from '../reducers/location.js';
import { selectPilotsByOrg } from '../reducers/user.js';
import {
    selectResourcesByTypeLoc,
    selelectResourcesByEventType,
    selectResourcesBy,
    selectResourcesTypesBy
} from '../reducers/resource.js';
import {
    isResourceAircraft,
    isResourceSimulator,
    isResourceInstructor,
    getInstructorIDByFilterResources
} from '../models/resource.js';
import { CONSTS, dateFormat } from '../configs/utils.js';

import { setProgress } from './ui.actions.js';
import {
    isEventSameOrganization,
    isEventSameLocation,
    isEventHasResource,
    checkEventByFilter,
    checkEventInFlight
} from '../models/event.js';

export const GET_AGENDA = 'GET_AGENDA';
export const GET_AGENDA_REQUEST = 'GET_AGENDA_REQUEST';
export const GET_AGENDA_FAILED = 'GET_AGENDA_FAILED';

export const GET_CALENDAR_EVENTS = 'GET_CALENDAR_EVENTS';
export const GET_CALENDAR_EVENTS_REQUEST = 'GET_CALENDAR_EVENTS_REQUEST';
export const GET_CALENDAR_EVENTS_FAILED = 'GET_CALENDAR_EVENTS_FAILED';

export const GET_EVENT = 'GET_EVENT';
export const GET_EVENT_REQUEST = 'GET_EVENT_REQUEST';
export const GET_EVENT_FAILED = 'GET_EVENT_FAILED';

export const ADD_EVENT = 'ADD_EVENT';
export const ADD_EVENT_REQUEST = 'ADD_EVENT_REQUEST';
export const ADD_EVENT_FAILED = 'ADD_EVENT_FAILED';
export const ADD_EVENT_SUCCESS = 'ADD_EVENT_SUCCESS';

export const SAVE_EVENT = 'SAVE_EVENT';
export const SAVE_EVENT_REQUEST = 'SAVE_EVENT_REQUEST';
export const SAVE_EVENT_FAILED = 'SAVE_EVENT_FAILED';
export const SAVE_EVENT_SUCCESS = 'SAVE_EVENT_SUCCESS';

export const MOVE_EVENT = 'MOVE_EVENT';
export const MOVE_EVENT_REQUEST = 'MOVE_EVENT_REQUEST';
export const MOVE_EVENT_FAILED = 'MOVE_EVENT_FAILED';

export const DELETE_EVENT = 'DELETE_EVENT';
export const DELETE_EVENT_REQUEST = 'DELETE_EVENT_REQUEST';
export const DELETE_EVENT_FAILED = 'DELETE_EVENT_FAILED';

export const CANCEL_EVENT = 'CANCEL_EVENT';
export const CANCEL_EVENT_REQUEST = 'CANCEL_EVENT_REQUEST';
export const CANCEL_EVENT_FAILED = 'CANCEL_EVENT_FAILED';

export const CHECKOUT_EVENT = 'CHECKOUT_EVENT';
export const CHECKOUT_EVENT_REQUEST = 'CHECKOUT_EVENT_REQUEST';
export const CHECKOUT_EVENT_FAILED = 'CHECKOUT_EVENT_FAILED';

export const CANCEL_CHECKOUT_EVENT = 'CANCEL_CHECKOUT_EVENT';
export const CANCEL_CHECKOUT_EVENT_REQUEST = 'CANCEL_CHECKOUT_EVENT_REQUEST';
export const CANCEL_CHECKOUT_EVENT_FAILED = 'CANCEL_CHECKOUT_EVENT_FAILED';

export const CHECKIN_EVENT = 'CHECKIN_EVENT';
export const CHECKIN_EVENT_REQUEST = 'CHECKIN_EVENT_REQUEST';
export const CHECKIN_EVENT_FAILED = 'CHECKIN_EVENT_FAILED';

export const CANCEL_CHECKIN_EVENT = 'CANCEL_CHECKIN_EVENT';
export const CANCEL_CHECKIN_EVENT_REQUEST = 'CANCEL_CHECKIN_EVENT_REQUEST';
export const CANCEL_CHECKIN_EVENT_FAILED = 'CANCEL_CHECKIN_EVENT_FAILED';

export const CHECK_ADD_TO_WAITING = 'CHECK_ADD_TO_WAITING';
export const CHECK_ADD_TO_WAITING_REQUEST = 'CHECK_ADD_TO_WAITING_REQUEST';
export const CHECK_ADD_TO_WAITING_FAILED = 'CHECK_ADD_TO_WAITING_FAILED';

export const GET_TIMEZONE_CURRENT_TIME = 'GET_TIMEZONE_CURRENT_TIME';
export const GET_TIMEZONE_CURRENT_TIME_REQUEST = 'GET_TIMEZONE_CURRENT_TIME_REQUEST';
export const GET_TIMEZONE_CURRENT_TIME_FAILED = 'GET_TIMEZONE_CURRENT_TIME_FAILED';

export const GET_FILTER_DATA_START = 'GET_FILTER_DATA_START';
export const GET_FILTER_DATA_FINISH = 'GET_FILTER_DATA_FINISH';

export const GET_INSTRUCTOR_BLOCK_EVENTS = 'GET_INSTRUCTOR_BLOCK_EVENTS';
export const GET_INSTRUCTOR_BLOCK_EVENTS_FAILED = 'GET_INSTRUCTOR_BLOCK_EVENTS_FAILED';
export const GET_INSTRUCTOR_BLOCK_EVENTS_REQUEST = 'GET_INSTRUCTOR_BLOCK_EVENTS_REQUEST';

export const GET_INSTRUCTOR_SCHEDULE = 'GET_INSTRUCTOR_SCHEDULE';
export const GET_INSTRUCTOR_SCHEDULE_FAILED = 'GET_INSTRUCTOR_SCHEDULE_FAILED';
export const GET_INSTRUCTOR_SCHEDULE_REQUEST = 'GET_INSTRUCTOR_SCHEDULE_REQUEST';
export const RESET_INSTRUCTOR_BLOCK_TIME = 'RESET_INSTRUCTOR_BLOCK_TIME';

export const SET_EDIT_EVENT_ID = 'SET_EDIT_EVENT_ID';
export const RESET_EDIT_EVENT_ID = 'RESET_EDIT_EVENT_ID';

export const UPDATE_WAITING_FAILD = 'UPDATE_WAITING_FAILD';
export const UPDATE_WAITING = 'UPDATE_WAITING';

export const GET_TIMEZONE_REQUEST = 'GET_TIMEZONE_REQUEST';
export const GET_TIMEZONE_SUCCESS = 'GET_TIMEZONE_SUCCESS';


import { getUserGroupsByOrgs } from './access-groups.js';

export const TIME_PAUSE_BEFORE_CHANGE = 70 * 60 * 1000;

export function getAgenda() {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: GET_AGENDA_REQUEST });

        const response = await api(
            {
                _model: 'calendar',
                _action: 'agenda'
            },
            getState
        );
        if (response.success) {
            return dispatch({ type: GET_AGENDA, payload: response });
        }
        return dispatch({ type: GET_AGENDA_FAILED });
    };
}

export function getCalendarEvents(filter, range = 0) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: GET_CALENDAR_EVENTS_REQUEST });
        const dayStart = dateFormat(
            Instadate.addDays(new Date(filter.date), -range),
            CONSTS.SYSTEM_DATE_FORMAT
        );
        const dayFinish = dateFormat(
            Instadate.addDays(new Date(filter.date), range),
            CONSTS.SYSTEM_DATE_FORMAT
        );
        const response = await api(
            {
                _model: 'calendar',
                _action: 'getEvents',
                dayStart,
                dayFinish,
                organizationFilter: filter.organizationID,
                locationFilter: filter.locationID,
                resourcesFilter: [filter.firstResourceID, filter.secondResourceID]
            },
            getState
        );
        if (response.success) {
            return dispatch({ type: GET_CALENDAR_EVENTS, payload: response });
        }
        return dispatch({ type: GET_CALENDAR_EVENTS_FAILED });
    };
}

export function checkAddToWaiting(event) {
    return async (dispatch, getState, { api }) => {
        try {
            dispatch({ type: CHECK_ADD_TO_WAITING_REQUEST });
            dispatch(setProgress(true, 'check-add-to-waiting'));
            const response = await api(
                {
                    _model: 'calendar',
                    _action: 'checkAddToWaiting',
                    ...event
                },
                getState
            );
            dispatch(setProgress(false, 'check-add-to-waiting'));
            if (response.success) {
                dispatch({ type: CHECK_ADD_TO_WAITING });
            } else {
                dispatch({ type: CHECK_ADD_TO_WAITING_FAILED });
            }
            return response;
        } catch (e) {
            dispatch({ type: CHECK_ADD_TO_WAITING_FAILED });
            return {};
        }
    };
}

export function getInstructorBusyTime(resourceID, organizationID, period) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: GET_INSTRUCTOR_BLOCK_EVENTS_REQUEST });
        dispatch(setProgress(true, 'get-instructor-block'));
        const dayStart = dateFormat(new Date(period.start), CONSTS.SYSTEM_DATE_FORMAT);
        const dayFinish = dateFormat(new Date(period.end), CONSTS.SYSTEM_DATE_FORMAT);
        const response = await api(
            {
                _model: 'calendar',
                _action: 'getInstructorBusyTime',
                dayStart,
                dayFinish,
                resourceID,
                organizationID
            },
            getState
        );
        dispatch(setProgress(false, 'get-instructor-block'));
        if (response.success) {
            return dispatch({ type: GET_INSTRUCTOR_BLOCK_EVENTS, payload: response });
        }
        return dispatch({ type: GET_INSTRUCTOR_BLOCK_EVENTS_FAILED });
    };
}

export const resetInstructorBlockTime = () => async dispatch =>
    dispatch({ type: RESET_INSTRUCTOR_BLOCK_TIME });

export function getInstructorNotWorkingTime(resourceID, organizationID, period) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: GET_INSTRUCTOR_SCHEDULE_REQUEST });
        const dayStart = dateFormat(new Date(period.start), 'Y/m/d 00:00:00');
        const dayFinish = dateFormat(new Date(period.end), 'Y/m/d 23:59:59');
        const response = await api(
            {
                _model: 'calendar',
                _action: 'getInstructorNotWorkingTime',
                dayStart,
                dayFinish,
                resourceID,
                organizationID
            },
            getState
        );
        if (response.success) {
            return dispatch({
                type: GET_INSTRUCTOR_SCHEDULE,
                payload: response
            });
        }
        return dispatch({ type: GET_INSTRUCTOR_SCHEDULE_FAILED, payload: response });
    };
}

export function changeEvent(nextEvent) {
    return (dispatch, getState) => {
        const state = getState();
        const organizationsList = state.OrganizationReducer.organizationsList;
        const locationsList = state.LocationReducer.calendarLocationsList;
        const oldEvent = state.CalendarReducer.Event.event;
        const event = {
            ...oldEvent,
            ...nextEvent
        };

        // STEPS
        // check organizationID
        if (!event.organizationID) {
            event.organizationID = organizationsList[0];
        }

        // check locationID
        if (!event.locationID) {
            event.locationID = selectLocationsByOrg(state, locationsList, event.organizationID)[0];
        }

        // check type
        if (!event.type) {
            event.type = 'air';
        }

        // check pilotID
        const pilotsList = selectPilotsByOrg(state, event.organizationID);
        if (!event.pilotID && pilotsList.indexOf(state.UserReducer.userID) > -1) {
            // If I'm instructor don't set me as pilot automatically
            if (event.instructorID !== state.UserReducer.userID) {
                event.pilotID = state.UserReducer.userID;
            }
        }

        // check finishTime
        if (!event.finishTime) {
            const startTime = new Date(event.startTime);
            const organizationSettings = getOrganizationSettings(state, event.organizationID).settings;
            const eventDefaultLength =
                Math.round(parseInt(organizationSettings.eventDefaultLength / 60, 10)) || 120;
            event.finishTime = dateFormat(
                Instadate.addMinutes(startTime, eventDefaultLength),
                CONSTS.SYSTEM_DATE_FORMAT
            );
        }

        // Check custom fields and convert them to object
        if (!event.customFields) {
            const customFields = getOrganizationSettings(state, event.organizationID).customFields;
            event.customFields = Object.keys(customFields).reduce(
                (acc, customFieldID) => ({
                    ...acc,
                    [customFieldID]: ''
                }),
                {}
            );
        }

        // resources should be array
        if (!event.resources) {
            event.resources = [];
        }

        // check pilotID
        // put all event data to reducer using formActions.onChange()
        dispatch(formActions.onChange('event', event));
    };
}

export function handleEventOrganizationChange(organizationID) {
    return dispatch => {
        dispatch(
            changeEvent({
                organizationID,
                locationID: null,
                instructorID: null,
                resources: null,
                resourcesList: []
            })
        );
        return true;
    };
}

export function handleEventLocationChange(locationID) {
    return dispatch => {
        dispatch(
            changeEvent({
                locationID,
                instructorID: null,
                resources: null,
                resourcesList: []
            })
        );
        return true;
    };
}

export function handleEventTypeChange(type) {
    return (dispatch, getState) => {
        const state = getState();
        const event = state.CalendarReducer.Event.event;

        dispatch(
            changeEvent({
                type,
                resourcesList: event.resourcesList
                    ? selelectResourcesByEventType(
                        state,
                        event.resourcesList,
                        type,
                        resource => !isResourceInstructor(resource)
                    )
                    : event.resourcesList
            })
        );
        return true;
    };
}

export function handleEventPilotChange(pilotID) {
    return dispatch => {
        dispatch(
            changeEvent({
                pilotID
            })
        );
        return true;
    };
}

export function handleEventSICPilotChange(secondInComandID) {
    return dispatch => {
        dispatch(
            changeEvent({
                secondInComandID
            })
        );
        return true;
    };
}

export function handleEventInstructorChange(instructorID) {
    return dispatch => {
        dispatch(
            changeEvent({
                instructorID
            })
        );
        return true;
    };
}

export function handleEventResourceChange(resourcesList) {
    return (dispatch, getState) => {
        const state = getState();
        const event = state.CalendarReducer.Event.event;
        const isMaintenance = event.type === 'maintenance';
        dispatch(
            changeEvent({
                resourcesList: [].concat(resourcesList)
            })
        );
        return isMaintenance;
    };
}

export function handleEventCommentChange(comments) {
    return dispatch => {
        dispatch(
            changeEvent({
                comments
            })
        );
    };
}

export function handleEventCustomFieldChange(customFields) {
    return dispatch => {
        dispatch(
            changeEvent({
                customFields
            })
        );
    };
}

export function handleEventStartTimeChange(startTime) {
    return (dispatch, getState) => {
        const state = getState();
        const oldStartTime = new Date(state.CalendarReducer.Event.event.startTime);
        const oldFinishTime = new Date(state.CalendarReducer.Event.event.finishTime);
        const lengthTime = oldFinishTime - oldStartTime;
        const finishTime = dateFormat(
            Instadate.addMilliseconds(new Date(startTime), lengthTime),
            CONSTS.SYSTEM_DATE_FORMAT
        );
        dispatch(
            changeEvent({
                startTime,
                finishTime
            })
        );
    };
}

export function handleEventFinishTimeChange(finishTime) {
    return dispatch => {
        dispatch(
            changeEvent({
                finishTime
            })
        );
    };
}

export function getEvent(organizationID, eventID) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: GET_EVENT_REQUEST });

        const response = await api(
            {
                organizationID,
                _model: 'calendar',
                _action: 'event',
                id: eventID
            },
            getState
        );

        if (response.success) {
            return dispatch({ type: GET_EVENT, payload: response });
        }
        return dispatch({ type: GET_EVENT_FAILED, payload: response });
    };
}

function getUrlName(state, event, url) {
    if (event.pilotID === state.UserReducer.userID) {
        return url.replace(/Event/g, 'MyEvent');
    }
    return url;
}

export function addEvent(event) {
    return async (dispatch, getState, { api }) => {
        try {
            dispatch({ type: ADD_EVENT_REQUEST });
            const state = getState();
            const filter = state.CalendarReducer.Filter.filter;
            const response = await api(
                {
                    _model: 'calendar',
                    _action:
                        event.type === 'maintenance'
                            ? 'addMaintenance'
                            : getUrlName(getState(), event, 'addEvent'),
                    ...event
                },
                getState
            );

            if (response.success && checkEventByFilter(filter, response.data.event)) {
                dispatch(getAgenda());
                dispatch({ type: ADD_EVENT, payload: response });
            } else {
                dispatch({ type: ADD_EVENT_FAILED, payload: response });
            }
            return response;
        } catch (e) {
            dispatch({ type: ADD_EVENT_FAILED, payload: {} });
            return {};
        }
    };
}

export function addEventSuccess() {
    return {
        type: ADD_EVENT_SUCCESS,
        payload: {}
    };
}

export function saveEvent(event) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: SAVE_EVENT_REQUEST, event });
        dispatch(setProgress(true, `${SAVE_EVENT}-${event.id}`));
        const response = await api(
            {
                _model: 'calendar',
                _action:
                    event.type === 'maintenance'
                        ? 'saveMaintenance'
                        : getUrlName(getState(), event, 'saveEvent'),
                ...event
            },
            getState
        );
        if (response.success) {
            dispatch(getAgenda());
            dispatch({ type: SAVE_EVENT, payload: response });
            dispatch(setProgress(false, `${SAVE_EVENT}-${event.id}`));
        } else {
            dispatch({ type: SAVE_EVENT_FAILED, payload: response });
            dispatch(setProgress(false, `${SAVE_EVENT}-${event.id}`));
        }
        return response;
    };
}

export function moveEvent(event) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: MOVE_EVENT_REQUEST, event });
        dispatch(setProgress(true, `${MOVE_EVENT}-${event.id}`));
        const response = await api(
            {
                _model: 'calendar',
                _action:
                    event.type === 'maintenance'
                        ? 'moveMaintenance'
                        : checkEventInFlight(0)(event)
                            ? 'moveEvent'
                            : 'moveEventFinish',
                id: event.id,
                organizationID: event.organizationID,
                locationID: event.locationID,
                startTime: event.startTime,
                finishTime: event.finishTime
            },
            getState
        );
        if (response.success) {
            dispatch(getAgenda());
            dispatch({ type: MOVE_EVENT, payload: response });
            dispatch(setProgress(false, `${MOVE_EVENT}-${event.id}`));
        } else {
            dispatch({ type: MOVE_EVENT_FAILED, payload: response });
            dispatch(setProgress(false, `${MOVE_EVENT}-${event.id}`));
        }
        return response;
    };
}

export function saveEventSuccess() {
    return {
        type: SAVE_EVENT_SUCCESS,
        payload: {}
    };
}

export function deleteEvent(event) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: DELETE_EVENT_REQUEST });
        const { id, organizationID, resourcesList, type } = event;
        const response = await api(
            {
                _model: 'calendar',
                _action: type === 'maintenance' ? 'deleteMaintenance' : 'deleteEvent',
                id,
                organizationID,
                resourcesList
            },
            getState
        );

        if (response.success) {
            dispatch(getAgenda());
            return dispatch({ type: DELETE_EVENT, payload: response, meta: { id } });
        }
        return dispatch({ type: DELETE_EVENT_FAILED, payload: response });
    };
}

export function cancelEvent(event, reason) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: CANCEL_EVENT_REQUEST });

        const response = await api(
            {
                organizationID: event.organizationID,
                _model: 'calendar',
                _action: getUrlName(getState(), event, 'cancelEvent'),
                id: event.id,
                reason
            },
            getState
        );

        if (response.success) {
            dispatch(getAgenda());
            return dispatch({ type: CANCEL_EVENT, payload: response, meta: { id: event.id } });
        }
        return dispatch({ type: CANCEL_EVENT_FAILED, payload: response });
    };
}

export function checkoutEvent(event) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: CHECKOUT_EVENT_REQUEST });

        const response = await api(
            {
                organizationID: event.organizationID,
                _model: 'calendar',
                _action: 'checkOutFinish',
                id: event.id
            },
            getState
        );

        if (response.success) {
            dispatch({ type: CHECKOUT_EVENT, payload: response, meta: { id: event.id } });
        } else {
            dispatch({ type: CHECKOUT_EVENT_FAILED, payload: response });
        }
        return response;
    };
}

export function cancelCheckoutEvent(event) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: CANCEL_CHECKOUT_EVENT_REQUEST });

        const response = await api(
            {
                organizationID: event.organizationID,
                _model: 'calendar',
                _action: 'cancelCheckOut',
                id: event.id
            },
            getState
        );

        if (response.success) {
            dispatch({ type: CANCEL_CHECKOUT_EVENT, payload: response, meta: { id: event.id } });
        } else {
            dispatch({ type: CANCEL_CHECKOUT_EVENT_FAILED, payload: response });
        }
        return response;
    };
}

export function cancelCheckinEvent(event) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: CANCEL_CHECKIN_EVENT_REQUEST });

        const response = await api(
            {
                organizationID: event.organizationID,
                _model: 'calendar',
                _action: 'cancelCheckIn',
                id: event.id
            },
            getState
        );

        if (response.success) {
            dispatch({ type: CANCEL_CHECKIN_EVENT, payload: response, meta: { id: event.id } });
        } else {
            dispatch({ type: CANCEL_CHECKIN_EVENT_FAILED, payload: response });
        }
        return response;
    };
}

function getHobbsValue(checkin) {
    let hobbsValue = '';
    if (checkin) {
        checkin.countersList.forEach(counterID => {
            const counter = checkin.counters[counterID];
            if (counter.type === 'hobbs') {
                hobbsValue = counter.newValue;
            }
        });
    }
    return hobbsValue;
}

export function changeCheckin(nextCheckin) {
    return (dispatch, getState) => {
        const state = getState();
        const resources = state.ResourceReducer.resources;
        const prevCheckin = state.CalendarReducer.Event.checkin;
        const checkin = {
            ...prevCheckin,
            ...nextCheckin
        };
        const event = state.CalendarReducer.Calendar.events[checkin.id];
        const organizationSettings = getOrganizationSettings(state, event.organizationID).settings;

        const eventLengthInHours = Instadate.differenceInHours(
            new Date(event.startTime),
            new Date(event.finishTime)
        );
        const prevHobbsValue = getHobbsValue(prevCheckin);
        let hobbsCounter = null;

        checkin.countersList.forEach(counterID => {
            if (!checkin.counters[counterID].newValue) {
                checkin.counters[counterID].newValue = '';
            }
            if (checkin.counters[counterID].type === 'hobbs') {
                hobbsCounter = checkin.counters[counterID];
            }
        });

        const checkinResourcesIsUndefined = typeof checkin.resources === 'undefined';

        if (checkinResourcesIsUndefined || !hobbsCounter || prevHobbsValue !== hobbsCounter.newValue) {
            let hobbsDiff = '0';
            if (hobbsCounter && hobbsCounter.newValue) {
                hobbsDiff = (parseFloat(hobbsCounter.newValue) - parseFloat(hobbsCounter.value)).toFixed(2);
                hobbsDiff = hobbsDiff > 0 ? hobbsDiff : '0';
            }
            let fitleredResourcesList = selectResourcesBy(
                state,
                event.resourcesList,
                resource => !isResourceAircraft(resource) && !isResourceSimulator(resource)
            );

            if (event.instructorID) {
                fitleredResourcesList = [event.instructorID].concat(fitleredResourcesList);
            }

            checkin.resources = fitleredResourcesList.reduce((acc, resourceID) => {
                const resource = resources[resourceID];

                if (
                    (isResourceInstructor(resource) &&
                        organizationSettings.instructorMeter === 'hobbs' &&
                        hobbsCounter) ||
                    (!isResourceInstructor(resource) &&
                        organizationSettings.resourceMeter === 'hobbs' &&
                        hobbsCounter)
                ) {
                    return {
                        ...acc,
                        [resourceID]: hobbsDiff.toString()
                    };
                }

                return {
                    ...acc,
                    [resourceID]: checkinResourcesIsUndefined
                        ? eventLengthInHours.toString()
                        : checkin.resources[resourceID]
                };
            }, {});
        }

        if (typeof checkin.comments === 'undefined') {
            checkin.comments = event.comments;
        }

        if (typeof checkin.customFields === 'undefined') {
            checkin.customFields = event.customFields;
        }

        dispatch(formActions.onChange('checkin', checkin));
    };
}

export function handleCheckinCounterValueChange(value, counter) {
    return (dispatch, getState) => {
        const state = getState();
        const checkin = state.CalendarReducer.Event.checkin;

        return dispatch(
            changeCheckin({
                counters: {
                    ...checkin.counters,
                    [counter.id]: {
                        ...checkin.counters[counter.id],
                        newValue: value
                    }
                }
            })
        );
    };
}

export function handleCheckinResourceValueChange(value, resourceID) {
    return (dispatch, getState) => {
        const state = getState();
        const checkin = state.CalendarReducer.Event.checkin;

        return dispatch(
            changeCheckin({
                resources: {
                    ...checkin.resources,
                    [resourceID]: value
                }
            })
        );
    };
}

export function handleCheckinCommentChange(comments) {
    return dispatch => {
        dispatch(
            changeCheckin({
                comments
            })
        );
    };
}

export function handleCheckinCustomFieldChange(customFields) {
    return dispatch => {
        dispatch(
            changeCheckin({
                customFields
            })
        );
    };
}

export function checkinEvent(checkin) {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: CHECKIN_EVENT_REQUEST });

        const response = await api(
            {
                _model: 'calendar',
                _action: 'checkInFinish',
                ...checkin
            },
            getState
        );

        if (response.success) {
            dispatch({ type: CHECKIN_EVENT, payload: response, meta: checkin });
        } else {
            dispatch({ type: CHECKIN_EVENT_FAILED, payload: response });
        }
        return response;
    };
}

function getRangeDates(date, range) {
    const convertDate = new Date(date);
    const rangeDates = {
        start: Instadate.addDays(convertDate, -range),
        end: Instadate.addDays(convertDate, range)
    };
    return rangeDates;
}

export function getFilterData(nextFilter = {}) {
    return async (dispatch, getState) => {
        dispatch({
            type: GET_FILTER_DATA_START
        });

        let state = getState();
        let organizationsList = state.OrganizationReducer.organizationsList;
        let organizationsListByNonExpired = selectOrganizationsListByNonExpired(
            state,
            organizationsList
        );
        let locationsList = state.LocationReducer.calendarLocationsList;
        let resourcesList = state.ResourceReducer.calendarResourcesList;
        let minimalFieldWeight = 0;
        const oldFilter = state.CalendarReducer.Filter.filter || {
            isHideStartBlock: true,
            isHideEndBlock: true
        };
        const nextFilterKeys = Object.keys(nextFilter);
        const fieldsWeights = {
            organizationID: 1,
            locationID: 2,
            resourcesFilter: 3,
            firstResourceID: 3,
            secondResourceID: 3,
            date: 4,
            period: 4
        };

        if (nextFilterKeys.length > 0) {
            nextFilterKeys.sort((fieldNameA, fieldNameB) => {
                const a = fieldsWeights[fieldNameA] || 10;
                const b = fieldsWeights[fieldNameB] || 10;
                return a > b ? 1 : a === b ? 0 : -1;
            });
            minimalFieldWeight = fieldsWeights[nextFilterKeys[0]];
        }
        const filter = {
            ...oldFilter,
            ...nextFilter
        };
        if (!filter.dateEdit) {
            filter.dateEdit = new Date();
        }
        const dateEdit = new Date(filter.dateEdit);
        const currentDate = new Date();
        const delta = currentDate - dateEdit;

        if (!filter.date || delta > TIME_PAUSE_BEFORE_CHANGE) {
            filter.date = dateFormat(currentDate, CONSTS.SYSTEM_DATE_FORMAT);
        }
        if (!filter.range) {
            filter.range = 7;
        }
        // if changed not only date field we shold reset period
        if (fieldsWeights.period > minimalFieldWeight) {
            filter.period = null;
        }

        if (
            !filter.organizationID ||
            !organizationsList ||
            fieldsWeights.organizationID > minimalFieldWeight
        ) {
            if (!organizationsList) {
                await dispatch(getUserOrganizations());
                state = getState();
                organizationsList = state.OrganizationReducer.organizationsList;
                organizationsListByNonExpired = selectOrganizationsListByNonExpired(
                    state,
                    organizationsList
                );
            }
            filter.organizationID = organizationsListByNonExpired[0] || null;
        }

        let showCalendar = null;
        let accessGroups = state.AccessGroupsReducer.accessGroups;
        if (accessGroups && accessGroups[filter.organizationID]) {
            showCalendar = accessGroups[filter.organizationID].calendarView;
        } else {
            await dispatch(getUserGroupsByOrgs(filter.organizationID));
            state = getState();
            accessGroups = state.AccessGroupsReducer.accessGroups;
            showCalendar =
                accessGroups && filter.organizationID
                    ? accessGroups[filter.organizationID].calendarView
                    : false;
        }

        // if we don't set location or organization ID has been changed
        if (!filter.locationID || fieldsWeights.locationID > minimalFieldWeight) {
            if (showCalendar && !locationsList && organizationsListByNonExpired.length > 0) {
                await dispatch(getCalendarLocationsByOrgs(organizationsListByNonExpired));
                state = getState();
                locationsList = state.LocationReducer.calendarLocationsList;
            }
            filter.locationID =
                selectLocationsByOrg(state, locationsList, filter.organizationID)[0] || null;
        }
        if (!filter.firstResourceID || fieldsWeights.firstResourceID > minimalFieldWeight) {
            if (showCalendar && !resourcesList && organizationsListByNonExpired.length > 0) {
                await dispatch(getCalendarResourcesByOrgs(organizationsListByNonExpired));
                state = getState();
                resourcesList = state.ResourceReducer.calendarResourcesList;
            }
            if (filter.locationID) {
                const resources = state.ResourceReducer.resources;
                const resourcesListByLoc = selectResourcesByTypeLoc(
                    state,
                    resourcesList,
                    null,
                    filter.locationID
                );
                const resourcesTypes = selectResourcesTypesBy(
                    resources,
                    resourcesListByLoc,
                    ['Aircraft', 'Instructor'],
                    filter.secondResourceID && resources[filter.secondResourceID].type
                );
                filter.firstResourceID =
                    (resourcesTypes[0] &&
                        selectResourcesByTypeLoc(
                            state,
                            resourcesList,
                            resourcesTypes[0],
                            filter.locationID
                        )[0]) ||
                    null;
            }
        }
        if (!filter.secondResourceID || fieldsWeights.secondResourceID > minimalFieldWeight) {
            if (showCalendar && !resourcesList && organizationsListByNonExpired.length > 0) {
                await dispatch(getCalendarResourcesByOrgs(organizationsListByNonExpired));
                state = getState();
                resourcesList = state.ResourceReducer.calendarResourcesList;
            }
            if (filter.locationID) {
                const resources = state.ResourceReducer.resources;
                const resourcesListByLoc = selectResourcesByTypeLoc(
                    state,
                    resourcesList,
                    null,
                    filter.locationID
                );
                const resourcesTypes = selectResourcesTypesBy(
                    resources,
                    resourcesListByLoc,
                    ['Aircraft', 'Instructor'],
                    filter.firstResourceID && resources[filter.firstResourceID].type
                );
                filter.secondResourceID =
                    (resourcesTypes[0] &&
                        selectResourcesByTypeLoc(
                            state,
                            resourcesList,
                            resourcesTypes[0],
                            filter.locationID
                        )[0]) ||
                    null;
            }
        }
        // метод Instadate.isDayBetween работает с выключкой https://github.com/Teamweek/instadate/blob/master/instadate.js#L294
        let dateInPeriod = false;
        if (filter.date && filter.period) {
            dateInPeriod = Instadate.isDayBetween(
                new Date(filter.date),
                new Date(filter.period.end),
                new Date(filter.period.start)
            );
        }
        if (fieldsWeights.date >= minimalFieldWeight && (!filter.period || !dateInPeriod)) {
            filter.period = getRangeDates(filter.date, filter.range);
            dispatch(getCalendarEvents(filter, filter.range));
        }
        if (!filter.period) {
            filter.period = getRangeDates(filter.date, filter.range);
        }
        const instructorID = getInstructorIDByFilterResources(state, filter);
        if (
            instructorID &&
            nextFilterKeys.some(
                nextFilterKey =>
                    !dateInPeriod ||
                    nextFilterKey.toLowerCase().includes('location') ||
                    nextFilterKey.toLowerCase().includes('resource') ||
                    nextFilterKey.toLowerCase().includes('organization')
            )
        ) {
            dispatch(getInstructorNotWorkingTime(instructorID, filter.organizationID, filter.period));
            dispatch(getInstructorBusyTime(instructorID, filter.organizationID, filter.period));
        }
        const usersList = Boolean(
            state.UserReducer.calendarPilotsListByOrganizations &&
            filter.organizationID &&
            state.UserReducer.calendarPilotsListByOrganizations[filter.organizationID]
        );
        if (showCalendar && !usersList && organizationsListByNonExpired.length > 0) {
            await dispatch(getCalendarPilotsByOrgs(organizationsListByNonExpired));
        }
        if (!filter.locationID) {
            filter.currentTimeLocation = null;
        }
        dispatch(formActions.onChange('filter', filter));
        dispatch({
            type: GET_FILTER_DATA_FINISH
        });
        return filter;
    };
}

export function getTimeZoneCurrentTime() {
    return async (dispatch, getState, { api }) => {
        dispatch({ type: GET_TIMEZONE_CURRENT_TIME_REQUEST });
        const state = getState();
        const locationID = state.CalendarReducer.Filter.filter
            ? state.CalendarReducer.Filter.filter.locationID
            : null;
        const timeZoneID =
            state.LocationReducer.locations && state.LocationReducer.locations[locationID]
                ? state.LocationReducer.locations[locationID].timeZoneID
                : null;
        if (timeZoneID) {
            const response = await api(
                {
                    _model: 'calendar',
                    _action: 'getTimeZoneCurrentTime',
                    timeZoneID
                },
                getState
            );

            if (response.success) {
                return dispatch(
                    getFilterData({
                        currentTimeLocation: response.data.currentTime
                    })
                );
            }
        }
        return dispatch({ type: GET_TIMEZONE_CURRENT_TIME_FAILED });
    };
}